module.exports = __webpack_public_path__ + "img/Add Patient - Blue.c4fcffb7.png";